import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    values: Array,
    labels: Array
  }

  connect() {
    this.draw()
  }

  draw() {
    const data = this.valuesValue.filter(v => v !== null)
    if (data.length < 2) return

    const canvas = this.element
    const ctx = canvas.getContext("2d")
    const width = canvas.offsetWidth || 200
    const height = canvas.height || 60
    canvas.width = width

    const min = Math.min(...data)
    const max = Math.max(...data)
    const range = max - min || 1

    const stepX = width / (data.length - 1)

    ctx.clearRect(0, 0, width, height)

    // Fill area under curve
    ctx.beginPath()
    ctx.moveTo(0, height - ((data[0] - min) / range) * (height - 8) - 4)
    data.forEach((v, i) => {
      const x = i * stepX
      const y = height - ((v - min) / range) * (height - 8) - 4
      ctx.lineTo(x, y)
    })
    ctx.lineTo(width, height)
    ctx.lineTo(0, height)
    ctx.closePath()
    ctx.fillStyle = "rgba(59, 130, 246, 0.1)"
    ctx.fill()

    // Line
    ctx.beginPath()
    ctx.strokeStyle = "rgb(59, 130, 246)"
    ctx.lineWidth = 1.5
    ctx.lineJoin = "round"
    data.forEach((v, i) => {
      const x = i * stepX
      const y = height - ((v - min) / range) * (height - 8) - 4
      i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y)
    })
    ctx.stroke()
  }
}
